export function isNextPaymentAfterPortout(
  anniversaryDate: string | undefined,
  mnpPortoutDate: string | undefined,
): boolean {
  if (!anniversaryDate || !mnpPortoutDate) {
    return false;
  }

  const portoutDate = new Date(mnpPortoutDate).getTime();
  const paymentDate = new Date(anniversaryDate).getTime();

  return portoutDate < paymentDate;
}
